
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CarrinhoSemPedidosContainer from "./CarrinhoSemPedidosContainer.vue";
import CarrinhoListaProdutosContainer from "./CarrinhoListaProdutosContainer.vue";

const AppbarState = namespace("Appbar");
const PedidoStore = namespace("Pedido");

@Component({
  name: "CarrinhoDrawerContainer",
  components: {
    CarrinhoSemPedidosContainer,
    CarrinhoListaProdutosContainer
  },
})
export default class CarrinhoDrawerContainer extends Vue {
  @AppbarState.Getter
  private getAppbarStatus!: any;

  @PedidoStore.Getter
  private getTotalProdutosPedido!: number;

  onCloseDrawer() {
    this.getAppbarStatus.carrinhoDrawer = !this.getAppbarStatus.carrinhoDrawer;
  }
}
